import { Activity, TAGS } from "components/planner/types"
import cropSo from "stores/library/crop"
import cycleSo from "stores/cycle"
import draftSo from "stores/draft"
import { SESSION_TYPE } from "stores/draft/type"
import guSo from "stores/growUnit"
import { getGrowUnitName } from "stores/growUnit/utils"
import { EDIT_TYPE } from "types/Entity"
import { Uuid } from "types/global"
import { getGrowUnitLayerName, getLayerByNumber } from "stores/growUnit/utils/layer"




export enum TOOLTIP_ALERT {
	OVERLAP,
	NEW,
	MODIFIED,
	PRODUCTION,
	AI,
}

type Tooltip = {
	title?: string,		// growunit
	phase?: string,		
	layerName?: string,	
	rows?: string[], 	// crop-lots
	alerts?: { type: TOOLTIP_ALERT, label: string }[],
}

/** restituisco il contenuto da visualizzare nel tooltip di un ACTIVITY di tipo CYCLE */
export function tooltipCycleFromActivity(activity: Activity): Tooltip {
	if (!activity) return null
	// è un activity DATA-ITEM
	if (activity.value != null) return null
	// verifico che non sia di tipi CYCLE
	const cycleUuid: Uuid = activity.tags?.[TAGS.CYCLES][0]
	if (!cycleUuid) return null

	const tooltip: Tooltip = {
		alerts: [],
		phase: activity.tags?.[TAGS.CYCLE_PHASE] ?? activity.tags?.[TAGS.GROWUNIT_PHASE],
	}

	// TITOLO e CROPS

	// provo a vedere se sta nello store dei cycles
	const cycle = cycleSo.getCycleByUuid(cycleUuid)
	const session = draftSo.getSessionSelect()

	// se non c'e provo a vedere se è una SESSION PREVIEW e lo cerco li
	if (!cycle) {
		const solutionCycle = session?.solution.solutionCycles.find(sc => sc.uuid == cycleUuid)
		const crop = cropSo.getByUuid(solutionCycle?.cropUuid)
		tooltip.rows = [crop?.name ?? "<CROP NOT FOUND>" ]
	} else {
		tooltip.rows = cycle.cropLots?.map(cl => cl.cropName) ?? [cycle.cropName ?? "< CROP NOT FOUND >"]
		const gu = guSo.getByID(cycle?.growUnitId)
		if (gu) tooltip.title = getGrowUnitName(gu)
		tooltip.layerName = getGrowUnitLayerName(gu, getLayerByNumber(gu, activity.tags?.[TAGS.LAYER_NUMBER]))
	}

	// ALERTS
	if ( session?.type == SESSION_TYPE.PREVIEW ) {
		if ( activity.tags?.[TAGS.SESSION] != SESSION_TYPE.PREVIEW) {
			tooltip.alerts.push({ type: TOOLTIP_ALERT.PRODUCTION, label: "Is in PRODUCTION" })
		} else {
			tooltip.alerts.push({ type: TOOLTIP_ALERT.AI, label: "It is a proposal from AI" })
		}
	}
	if ( activity.tags?.[TAGS.EDIT] == EDIT_TYPE.MODIFIED) {
		tooltip.alerts.push({ type: TOOLTIP_ALERT.MODIFIED, label: "It has been modified" })
	} else if (activity.tags?.[TAGS.EDIT] == EDIT_TYPE.NEW) {
		tooltip.alerts.push({ type: TOOLTIP_ALERT.NEW, label: "it's a new CYCLE" })
	}
	if (activity.overlaps?.length > 0) {
		tooltip.alerts.push({ type: TOOLTIP_ALERT.OVERLAP, label: "There are overlaps" })
	}

	return tooltip
}